import { type ButtonHTMLAttributes, type ReactNode, type Ref } from 'react';
import clsx from 'clsx';
import './GoogleSignInButton.css';

export interface GoogleSignInButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Button label — "Sign in with Google" / "შედი Google-ით" / etc. */
  children: ReactNode;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * GoogleSignInButton — white pill with Google brand "G" + a label.
 * Google's branding rules require a white (or very light) background
 * with their colored G; this primitive matches that while staying
 * on-brand with the rest of our 3D chunky system via the inset
 * bottom-edge shadow shared with <Button variant="neutral">.
 */
export function GoogleSignInButton({
  children,
  type,
  className,
  ref,
  ...rest
}: GoogleSignInButtonProps) {
  return (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={clsx('fluent-gsi', className)}
      {...rest}
    >
      <GoogleG />
      <span>{children}</span>
    </button>
  );
}

function GoogleG() {
  // Official Google G with their brand colors.
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C33.9 6.2 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c10.4 0 19-7.6 20-17 .1-.5.1-1.7 0-3.2-.1-1.2-.2-2.3-.4-3.3z" />
      <path fill="#FF3D00" d="M6.3 14.7 13 19.6c1.8-4.4 6.1-7.6 11-7.6 3 0 5.8 1.1 7.9 3l5.7-5.7C33.9 6.2 29.2 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.1 0 9.7-1.9 13.2-5.1l-6.1-5.2c-2 1.4-4.5 2.3-7.1 2.3-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.4l6.1 5.2c-.4.4 6.6-4.8 6.6-14.6 0-1.3-.1-2.3-.4-3.5z" />
    </svg>
  );
}
